import * as types from "../actions/actionsTypes";

let initialState = {
  activeGroups: [],
};

const optanonReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ACTIVE_GROUPS:
      return {
        ...state,
        activeGroups: action.data,
      };

    default:
      return state;
  }
};

export default optanonReducer;
